import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const WorkerCountField = ({ value, onChange, disabled }) => {
  const handleChange = (event) => {
    onChange(event, {
      name: 'worker_count',
      value: event.target.value,
    });
  };

  return (
    <FormControl fullWidth>
      <InputLabel id='worker-count-label'>Number of Workers</InputLabel>
      <Select
        labelId='worker-count-label'
        id='worker-count'
        name='worker_count'
        value={value}
        label='Number of Workers'
        onChange={handleChange}
        disabled={disabled}
        variant='outlined'
      >
        {new Array(20).fill().map((e, i) => {
          const count = i + 1;
          return (
            <MenuItem key={count} value={count}>
              {count}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default WorkerCountField;

